<template>
    <div class="countdown-timer">
        <slot name="timer">
            {{ totalSeconds.asSeconds() <= 0 ? 'closed' : totalSeconds.format('m:ss') }}
        </slot>
    </div>
</template>

<script lang="ts" setup>
import dayjs from 'dayjs';
import duration, { Duration } from 'dayjs/plugin/duration';
import {
    ref, onUnmounted, watch,
} from 'vue';
import { getNextPeriodBoundary } from '@/utils/periodUtils.ts';

dayjs.extend(duration);

const props = defineProps<{
    useTradingPeriod?: boolean;
}>();

const emit = defineEmits(['finished']);

const totalSeconds = ref<Duration>(dayjs.duration(0, 'seconds'));
const nextHalfHour = ref<dayjs.Dayjs>(dayjs());
let interval: ReturnType<typeof setInterval> | null = null;

function start (): void {
    interval = setInterval(() => {
        if (totalSeconds.value.asSeconds() > 0) {
            setCountdownExpiryInSeconds();
        } else {
            emit('finished');
            clearInterval(interval!);
        }
    }, 1000);
}

function setCountdownExpiryTimeInSeconds (): void {
    nextHalfHour.value = getNextPeriodBoundary(dayjs(), props.useTradingPeriod);
}

function initialise (): void {
    setCountdownExpiryTimeInSeconds();
    setCountdownExpiryInSeconds();
    start();
}

function setCountdownExpiryInSeconds (): void {
    totalSeconds.value = dayjs.duration(nextHalfHour.value.diff(dayjs(), 'seconds'), 'seconds');
}

function restart (): void {
    clearInterval(interval!);
    setCountdownExpiryTimeInSeconds();
    setCountdownExpiryInSeconds();
    start();
}

defineExpose({
    restart,
});

watch(() => props.useTradingPeriod, restart);

onUnmounted((): void => {
    clearInterval(interval!);
});

initialise();
</script>

<style lang="scss" scoped>

.countdown-timer {
    width: 35px;
    color: var(--lcpWatermelon);
}

</style>
